import type { ThemeOptionVariant } from '../../augmentation'
/**
 * Base-unit size for our fonts and spacings tokens!
 * Be aware this is having influence on all variants and their tokens!
 */
export const getBaseUnit = (variant: ThemeOptionVariant) => {
  switch (variant) {
    case 'desktop':
      return 14.4
    case 'md':
      return 22.4
    case 'lg':
      return 24
    case 'xl':
      return 40
    case 'mobile':
    case 'tablet':
    default:
      return 16
  }
}
